



























































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PropertyService from '@/services/properties';
import Property from '@/entities/Property';
import { Route } from 'vue-router';
import Model from '@/entities/Model';
import ModalService from '@/services/modal';
import CarOption from '@/entities/CarOption';
import CarDamage from '@/entities/CarDamage';

@Component
export default class Settings extends Vue {
    propertyService = new PropertyService();

    modalService = new ModalService();

    properties: any = [];

    newProperty: any;

    makes: Property[];

    loading = false;

    saving: string = null;

    deleting: string = null;

    propertyTypes = [
        {
            title: 'Makes',
            route: 'makes',
        },
        {
            title: 'Models',
            route: 'models',
        },
        /* {
            title: 'Fuel',
            route: 'fuel-types',
        },
        {
            title: 'Transmission',
            route: 'transmission-types',
        },
        {
            title: 'Colors',
            route: 'colors',
        }, */
        {
            title: 'Options',
            route: 'options',
        },
        {
            title: 'Damages',
            route: 'damages',
        },
    ];

    get currentProperty() {
        return this.$route.params.property;
    }

    mounted() {
        this.fetch(this.$route);

        this.propertyService.list('makes').then((makes) => {
            this.makes = makes;
        });
    }

    save(property: any) {
        if (!this.saving && !this.deleting) {
            this.saving = property.id;
            return this.propertyService
                .save(this.currentProperty, property)
                .catch(() => {
                    this.modalService.showInfoModal(
                        'Error',
                        `Could not save ${this.currentProperty}. Make sure you've filled in everything needed`,
                    );
                })
                .finally(() => {
                    this.saving = null;
                });
        }

        this.modalService.showInfoModal(
            'Please wait',
            'You can\'t execute multiple actions at the same time',
        );
        return null;
    }

    create() {
        this.saving = '';
        this.save(this.newProperty)
            .then((property: any) => {
                this.properties.push(property);
                this.freshNewProperty();
            })
            .finally(() => {
                this.saving = null;
            });
    }

    remove(property: any) {
        this.deleting = property.id;
        this.propertyService.delete(this.currentProperty, property)
            .then(() => {
                for (let n = 0; n < this.properties.length; n += 1) {
                    if (this.properties[n].id === property.id) {
                        this.properties.splice(n, 1);
                        break;
                    }
                }
            })
            .catch(({ response }) => {
                this.modalService.showInfoModal('Error', response.data.message);
            })
            .finally(() => {
                this.deleting = null;
            });
    }

    freshNewProperty() {
        if (this.currentProperty === 'model') {
            this.newProperty = new Model();
            return;
        }
        if (this.currentProperty === 'option') {
            this.newProperty = new CarOption();
            return;
        }
        if (this.currentProperty === 'damage') {
            this.newProperty = new CarDamage();
            return;
        }

        this.newProperty = new Property();
    }

    @Watch('$route', { immediate: true, deep: true })
    fetch(route: Route) {
        this.freshNewProperty();
        this.properties = [];

        if (this.currentProperty) {
            this.loading = true;
            this.propertyService.list(this.currentProperty)
                .then((properties) => {
                    this.properties = properties;
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
